function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 12");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.00012962963 0 105 0 105 105 0.00012962963 105"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Calendar",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.-Calendar-Copy",
  transform: "translate(-163.000000, -332.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12",
  transform: "translate(163.000000, 332.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.00012962963,52.5 C0.00012962963,81.4955556 23.5045741,105 52.5001296,105 C81.4943889,105 105.00013,81.4955556 105.00013,52.5 C105.00013,23.5044444 81.4943889,0 52.5001296,0 C23.5045741,0 0.00012962963,23.5044444 0.00012962963,52.5",
  id: "Fill-1",
  fill: "#EEEFF4",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-4",
  fill: "#B3C0CB",
  points: "22 35.8906067 22 31 82 31 82 42 22 42"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-5",
  fill: "#E6EBF0",
  cx: 71,
  cy: 40,
  r: 2
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-10",
  fill: "#D2DCE4",
  points: "22 36 40.8985706 36 42.6163884 40.246722 82 40.246722 82 79 22 79"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#5B6C7A",
  cx: 48,
  cy: 35,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-7",
  fill: "#5B6C7A",
  cx: 42.5,
  cy: 26.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#5B6C7A",
  x: 63,
  y: 30,
  width: 3,
  height: 3
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy",
  fill: "#D2DCE4",
  cx: 28,
  cy: 23,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-8",
  fill: "#D2DCE4",
  cx: 53,
  cy: 25,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-9",
  fill: "#D2DCE4",
  cx: 63,
  cy: 19,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-6",
  fill: "#D2DCE4",
  cx: 60,
  cy: 37,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-10",
  fill: "#B3C0CB",
  cx: 44,
  cy: 20,
  r: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#D2DCE4",
  transform: "translate(54.239888, 31.275225) rotate(-40.000000) translate(-54.239888, -31.275225) ",
  x: 52.2398879,
  y: 30.7752247,
  width: 4,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-4",
  fill: "#5B6C7A",
  transform: "translate(69.239888, 26.275225) rotate(32.000000) translate(-69.239888, -26.275225) ",
  x: 67.2398879,
  y: 25.7752247,
  width: 4,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-2",
  fill: "#5B6C7A",
  transform: "translate(33.239888, 31.275225) rotate(-4.000000) translate(-33.239888, -31.275225) ",
  x: 31.2398879,
  y: 30.7752247,
  width: 4,
  height: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FEFEFE",
  opacity: 0.486746652,
  cx: 52.5,
  cy: 57.5,
  r: 7.5
}))));

var SvgEmptyState = function SvgEmptyState(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105px",
    height: "105px",
    viewBox: "0 0 105 105",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyState, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty_state.80e99dd4.svg";
export { ForwardRef as ReactComponent };